export const headerOption = [
  {
    key: "H01",
    text: "H01 - Entry Type Non AD/CVD to AD/CVD",
    value: "H01",
    description:
      `The Entry Type
      Code has been changed from a type that does not have
      AD/CVD (e.g., 01) to a type that does have AD/CVD
      (e.g., 03).`,
  },
  {
    key: "H02",
    text: "H02 - Entry Type-Other",
    value: "H02",
    description:
      `The Entry Type Code has been
      changed (other than the types indicated by PSC Header
      Reason Code H01 or H14).`,
  },
  {
    key: "H04",
    text: "H04 - Mode of Transportation",
    value: "H04",
    description: `The Mode of Transportation
    (MOT) Code has changed.`,
  },
  {
    key: "H05",
    text: "H05 - Bond-Surety",
    value: "H05",
    description: `The basic and/or additional Surety
    Company Code has changed. `,
  },
  {
    key: "H06",
    text: "H06 - Bond-Superseding",
    value: "H06",
    description: `The Continuous Superseded Bond
    Indicator has changed.`,
  },
  {
    key: "H07",
    text: "H07 - Bond-Other",
    value: "H07",
    description:
      `Other basic and/or additional bond data has
      changed. Includes Bond Type Code, Single Transaction
      Bond Amount, Single Transaction Bond Producer
      Account Number, Bond Waiver Indicator, Bond Waiver
      Reason Code.`,
  },
  {
    key: "H08",
    text: "H08 - Electronic Invoice Availability",
    value: "H08",
    description: `The Electronic Invoice
    Indicator has changed.`,
  },
  {
    key: "H09",
    text: "H09 - Shipment Usage Type",
    value: "H09",
    description: `The Shipment Usage Type Code
    has changed.`,
  },
  {
    key: "H10",
    text: "H10 - Consignee",
    value: "H10",
    description: "The Consignee Number has changed",
  },
  {
    key: "H11",
    text: "H11 - Date of Importation",
    value: "H11",
    description: `The Date of Importation has
    changed.`,
  },
  {
    key: "H12",
    text: "H12 - State of Destination",
    value: "H12",
    description: `The U.S. State of Destination Code has changed.`,
  },
  {
    key: "H13",
    text: "H13 - Header Fee",
    value: "H13",
    description:
      `One or more Entry Summary Header Fee
      (Header Fee Amount or Accounting Class Code) has
      changed. Includes 311 (Informal Entry Fee), 500
      (Manual Surcharge), and 496 (Mail).`,
  },
  {
    key: "H14",
    text: "H14 - Entry Type AD/CVD-to-Non-AD/CVD",
    value: "H14",
    description:
      `The Entry Type
      Code has been changed from a type that does have
      AD/CVD (e.g., 03) to a type that does not have AD/CVD
      (e.g., 01).`,
  },
  {
    key: "H99",
    text: "H99 - Data Change-Other",
    value: "H99",
    description:
      `Another Entry Summary Header
      Grouping data element, not listed above, has changed.
      Clearly describe the reason for the change in the PSC
      Filing Explanation grouping (36-Record). `,
  },
];

export const lineItemOptions = [
  {
    key: "L01",
    text: "L01 - Invoice",
    value: "L01",
    description:
      `The commercial invoice has changed or items
      (i.e., lines) were missed in the original submission. This
      change may result in more or fewer Entry Summary Line
      Item Groupings. `,
  },
  {
    key: "L02",
    text: "L02 - SPI ",
    value: "L02",
    description:
      `The Trade Agreement / Special Program Claim
      Code has changed (but not the article classification). `,
  },
  {
    key: "L03",
    text: "L03 - Classification",
    value: "L03",
    description:
      `The classification of an article has
      changed; the HTS Number has changed. This may
      affect the Article Set Indicator and/or the Trade
      Agreement / Special Program Claim Code. `,
  },
  {
    key: "L04",
    text: "L04 - Value",
    value: "L04",
    description:
      `The value of the merchandise has changed (i.e.,
        the Value of Goods Amount) or the basis/determination
        for the value has changed (e.g., the NAFTA Net Cost
        Indicator). This reason may be used if a currency
        conversion was a factor that resulted in a change to the
        value.`,
  },
  {
    key: "L05",
    text: "L05 - Non-Dutiable Charges",
    value: "L05",
    description: "The charges Amount has changed.",
  },
  {
    key: "L06",
    text: "L06 - Duty",
    value: "L06",
    description: "The Duty Amount has changed.",
  },
  {
    key: "L07",
    text: "L07 - COO",
    value: "L07",
    description: "The Country of Origin has changed.",
  },
  {
    key: "L08",
    text: "L08 - COE",
    value: "L08",
    description: "The Country of Export has changed.",
  },
  {
    key: "L09",
    text: "L09 - AD/CVD Case-Critical Circumstances",
    value: "L09",
    description:
      `The U.S.
      Department of Commerce has invoked 'Critical
      Circumstances' (regarding an Entry Type 01 Entry
      Summary filed 90 days prior to the Preliminary or Order
      period for an AD/CVD case).`,
  },
  {
    key: "L10",
    text: "L10 - AD/CVD Case-Party",
    value: "L10",
    description:
      `One or more Article Party
      Identifier(s) has changed; thus changing the AD/CVD
      case suffix.`,
  },
  {
    key: "L11",
    text: "L11 - AD/CVD Case-Rate",
    value: "L11",
    description:
      "The Case Deposit Rate and/or Case Rate Type Qualifier Code has changed.",
  },
  {
    key: "L12",
    text: "L12 - AD/CVD Case-Scope",
    value: "L12",
    description: "The scope of the AD/CVD case has changed.",
  },
  {
    key: "L13",
    text: "L13 - AD/CVD Case-Non-Reimbursement Statement",
    value: "L13",
    description:
      "The AD/CVD Non-Reimbursement Statement and/or AD/CVD Non-Reimbursement Declaration identifier has changed.",
  },
  {
    key: "L14",
    text: "L14 - Ruling",
    value: "L14",
    description: "The Ruling Type Code or Ruling Number has changed.",
  },
  {
    key: "L15",
    text: "L15 - PGA-FCC",
    value: "L15",
    description:
      "The 740 Header and/or 740 Continuation has changed (Includes a change to an FCC PGA Invoice Description)",
  },
  {
    key: "L16",
    text: "L16 - Tax",
    value: "L16",
    description:
      "The IR Tax information (IR Tax Amount or Accounting Class Code) has changed.",
  },
  {
    key: "L17",
    text: "L17 - MPF",
    value: "L17",
    description:
      "The Formal Merchandise Processing Fee (499) (User Fee Amount or Accounting Class Code) has changed.",
  },
  {
    key: "L18",
    text: "L18 - Fee-Other",
    value: "L18",
    description:
      `Another fee has changed (User Fee Amount
        or Accounting Class Code). Includes a change to 501-
        HMF or any agriculture commodity fee. `,
  },
  {
    key: "L19",
    text: "L19 - Manufacturer",
    value: "L19",
    description: "The Manufacturer / Supplier Code has changed.",
  },
  {
    key: "L20",
    text: "L20 - Foreign Exporter",
    value: "L20",
    description: "The Foreign Exporter Code has changed.",
  },
  {
    key: "L21",
    text: "L21 - Sold to Party",
    value: "L21",
    description: "The Sold to Party Identifier has changed.",
  },
  {
    key: "L22",
    text: "L22 - Delivered to Party",
    value: "L22",
    description: "The Delivered to Party Identifier has changed.",
  },
  {
    key: "L23",
    text: "L23 - Textile Category",
    value: "L23",
    description: "The Category Code (for textiles) has changed",
  },
  {
    key: "L24",
    text: "L24- Standard Visa",
    value: "L24",
    description: "The standard Visa Number has changed.",
  },
  {
    key: "L25",
    text: "L25 - Textile Export Date",
    value: "L25",
    description: "The Date of Exportation (for textiles) has changed.",
  },
  {
    key: "L26",
    text: "L26 - License/Certificate/Permit",
    value: "L26",
    description:
      "The License/Certificate/Permit Type Code and/or License Number/Certificate Number/Permit Number has changed.",
  },
  {
    key: "L27",
    text: "L27 - Softwood Lumber Export Price",
    value: "L27",
    description: "The Softwood Lumber Export Price amount has changed.",
  },
  {
    key: "L28",
    text: "L28 - Softwood Lumber Export Charges",
    value: "L28",
    description: "The Softwood Lumber Export charges amount has changed,",
  },
  {
    key: "L29",
    text: "L29 - Quantity Change",
    value: "L29",
    description:
      `Quantity (1, 2, or 3) has changed on
      any HTS Number for the article.`,
  },
  {
    key: "L30",
    text: "L30 - Relationship Change",
    value: "L30",
    description: "The Related Party Indicator has changed.",
  },
  {
    key: "L31",
    text: "L31 - Shipping Weight",
    value: "L31",
    description: "The Gross Shipping Weight has changed.",
  },
];
